/**
 * A total the grid can't work out itself, e.g. an infinite-scroll grid whose total comes
 * from the server. `capped` means the real total is larger than `count`.
 */
export type GridTotal = number | { count: number; capped: boolean };

/**
 * Holds a total that isn't known by the grid itself, e.g. an infinite-scroll
 * grid whose total comes from a separate count request. null means loading;
 * undefined means unknown, and the status bar hides the total.
 */
export type GridTotalStore = {
  get: () => GridTotal | null | undefined;
  set: (value: GridTotal | null | undefined) => void;
  subscribe: (listener: () => void) => () => void;
};

export const createGridTotalStore = (): GridTotalStore => {
  let value: GridTotal | null | undefined = null;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set: (next) => {
      value = next;
      listeners.forEach((l) => l());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export const noStore: GridTotalStore = {
  get: () => null,
  set: () => undefined,
  subscribe: () => () => undefined,
};
